import LenderFilterQuery from "./LenderFilterQuery";

export default class LenderFilterQueryFactory {
    static make(): LenderFilterQuery {
        return new LenderFilterQuery();
    }
}
